<template>
  <b-container>
    <h1 class="mt-2">Word Counter</h1>
    <words />
  </b-container>
</template>

<script type="ts">
import { Vue, Component } from 'vue-property-decorator';
import Words from '@/components/Words.vue'

@Component({
  components: {
    Words
  }
})
export default class Word extends Vue { 

}
</script>